import { values } from 'ramda';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { LastJobTokenSelector } from '../selectors/address.component.selectors';
export var VALIDATE_ADDRESS_CONSTANTS = {
  BEGIN: 'VALIDATE_ADDRESS_BEGIN',
  SUCCESS: 'VALIDATE_ADDRESS_SUCCESS',
  FAILURE: 'VALIDATE_ADDRESS_FAILURE'
};
export var SET_ADDRESS_TO_BE_VALIDATED = 'SET_ADDRESS_TO_BE_VALIDATED';
export var SET_ADDRESS_KEY_FOR_ADDRESS_BEING_VALIDATED_THROUGH_API = 'SET_ADDRESS_KEY_FOR_ADDRESS_BEING_VALIDATED_THROUGH_API';
export var SET_ADDRESS_TO_VALIDATED_ADDRESSES = 'SET_ADDRESS_TO_VALIDATED_ADDRESS';
export var SET_ADDRESS_KEY_FOR_ADDRESS_PREVIOUSLY_VALIDATED_THROUGH_API = 'SET_ADDRESS_KEY_FOR_ADDRESS_PREVIOUSLY_VALIDATED_THROUGH_API';
export var SET_SUGGESTED_ADDRESS_TO_VALIDATED_ADDRESSES = 'SET_SUGGESTED_ADDRESS_TO_VALIDATED_ADDRESS';
export var SET_FORCE_SHOW_EDIT_FORM_ADDRESSES_COMPONENT = 'SET_FORCE_SHOW_EDIT_FORM_ADDRESSES_COMPONENT';
export var SET_EDIT_ADDRESS_BACK_TO_INVALID = 'SET_EDIT_ADDRESS_BACK_TO_INVALID';
export var setAddress = function setAddress(address) {
  return {
    type: SET_ADDRESS_TO_BE_VALIDATED,
    payload: address
  };
};
var validateAddressPromise = function validateAddressPromise(dispatch, address, token, addressTypes) {
  return ThunkHelper(dispatch, values(VALIDATE_ADDRESS_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/ValidateAddress',
    data: {
      Address: {
        City: address.city,
        Country: address.country,
        LineOne: address.addressLine1,
        LineTwo: address.addressLine2,
        Name: address.addressLine1,
        //mimicking existing pattern for populating name
        PostalCode: address.postalCode,
        State: address.stateRegionProvince,
        DefaultBilling: addressTypes.DefaultBilling,
        DefaultHome: addressTypes.DefaultHome,
        DefaultPostal: addressTypes.DefaultPostal,
        DefaultService: addressTypes.DefaultService,
        DefaultShipping: addressTypes.DefaultShipping,
        DefaultWork: addressTypes.DefaultWork
      },
      JobToken: token
    }
  });
};
export var validateAddress = function validateAddress(addressKey, address, token, addressTypes) {
  return function (dispatch, getState) {
    dispatch(setAddressKeyForAddressPreviouslyValidatedThroughAPI(null));
    dispatch(setAddressKeyForAddressBeingValidatedThroughApi(addressKey));
    var lastJobToken = LastJobTokenSelector(getState());
    return validateAddressPromise(dispatch, address, lastJobToken, addressTypes);
  };
};
export var setAddressToValidatedAddress = function setAddressToValidatedAddress(address, jobToken, addressValidationStatus) {
  return {
    type: SET_ADDRESS_TO_VALIDATED_ADDRESSES,
    payload: {
      address: address,
      JobToken: jobToken,
      AddressValidationStatus: addressValidationStatus
    }
  };
};
export var setAddressKeyForAddressBeingValidatedThroughApi = function setAddressKeyForAddressBeingValidatedThroughApi(addressKey) {
  return {
    type: SET_ADDRESS_KEY_FOR_ADDRESS_BEING_VALIDATED_THROUGH_API,
    payload: addressKey
  };
};
export var setAddressKeyForAddressPreviouslyValidatedThroughAPI = function setAddressKeyForAddressPreviouslyValidatedThroughAPI(addressKey) {
  return {
    type: SET_ADDRESS_KEY_FOR_ADDRESS_PREVIOUSLY_VALIDATED_THROUGH_API,
    payload: addressKey
  };
};
export var RESET_ADDRESS_COMPONENT = 'RESET_ADDRESS_COMPONENT';
export var resetAddressComponent = function resetAddressComponent() {
  return {
    type: RESET_ADDRESS_COMPONENT
  };
};
export var setSuggestedAddressToValidatedAddress = function setSuggestedAddressToValidatedAddress(address, jobToken) {
  return {
    type: SET_SUGGESTED_ADDRESS_TO_VALIDATED_ADDRESSES,
    payload: {
      address: address,
      JobToken: jobToken
    }
  };
};
export var setForceShowEditFormAddress = function setForceShowEditFormAddress(status) {
  return {
    type: SET_FORCE_SHOW_EDIT_FORM_ADDRESSES_COMPONENT,
    payload: status
  };
};
export var setEditAddressBackToInvalid = function setEditAddressBackToInvalid(address, response) {
  return {
    type: SET_EDIT_ADDRESS_BACK_TO_INVALID,
    payload: {
      address: address,
      response: response
    }
  };
};